module.exports = __webpack_public_path__ + "static/media/kaison.c0a87433.jpg";